// You can use CONSTANTS.js file for below definitions of constants and import here.
export const SIZE_CHANGED = "SIZE_CHANGED";
export const MENU_COLLAPSED_CHANGED = "MENU_COLLAPSED_CHANGED";
export const CURRENT_ROUTE = "CURRENT_ROOT";
export const APP_INFO = "APP_INFO";
export const REHYDRATION_COMPLETE = "REHYDRATION_COMPLETE";

export const ChangeSize = (payload) => ({
  type: SIZE_CHANGED,
  payload
})

export const ChangeMenuCollapsed = (payload) => ({
  type: MENU_COLLAPSED_CHANGED,
  payload
})

export const UpdateCurrentRoot = (payload) => ({
  type: CURRENT_ROUTE,
  payload
})

export const UpdateAppInfo = (payload) => ({
  type: APP_INFO,
  payload
})

export const SetRehydrationComplete = () => ({
  type: REHYDRATION_COMPLETE
})